// extracted by mini-css-extract-plugin
export var container = "_dd-0";
export var containerTopRight = "_dd-1";